import { render, staticRenderFns } from "./ClassGroupSettingWidget.vue?vue&type=template&id=c559a00e&scoped=true&"
import script from "./ClassGroupSettingWidget.vue?vue&type=script&lang=js&"
export * from "./ClassGroupSettingWidget.vue?vue&type=script&lang=js&"
import style0 from "./ClassGroupSettingWidget.vue?vue&type=style&index=0&id=c559a00e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c559a00e",
  null
  
)

export default component.exports